import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconMenu = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path height="100%" width="100%" y="0" x="0" d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
  </SvgIcon>
);

export default IconMenu;



// WEBPACK FOOTER //
// ./src/components/icons/IconMenu.js